<template>

  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">参数设置</div>
      <el-form-item label="报单开关" :rules="[{required: true,message: ' '}]" prop="is_open">
        <div>
          <el-radio v-model="form.is_open" :label="1">开启</el-radio>
          <el-radio v-model="form.is_open" :label="0">关闭</el-radio>
        </div>
      </el-form-item>
      

      <el-form-item label="报单奖励：">
        <div style="max-width: 800px;">
          <el-table :data="gradeList" border  style="width: 100%">
            <el-table-column prop="name" label="等级">
            </el-table-column>
            <el-table-column prop="name" label="报单奖励">
              <template v-slot="scope">
                  <el-input type="number" min="0" v-model="scope.row.grade_award">
                    <template slot="append">
                      %
                    </template>
                  </el-input>
              </template>
              
            </el-table-column>
            <el-table-column prop="name" label="双重奖励">
              <template v-slot="scope">
                  <el-input type="number" min="0" v-model="scope.row.double_money">
                    <template slot="append">
                      %
                    </template>
                  </el-input>
              </template>
              
            </el-table-column>
            <el-table-column prop="name" label="平级奖励">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.same_award" min="0" type="number" placeholder="请输入数字额">
                    <template slot="append">%</template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="gray9">报单奖励按照级差计算</div>
      </el-form-item>

      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import Notetaking from '@/api/notetaking.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,//
          grade_money:'',
          double_money:0
        },
        gradeList:[],
        /*是否打开图片选择*/
        isupload:false,
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        Notetaking.getSetting({}, true).then(res => {
            let setting = res.data.setting;
            self.form = formatModel(self.form, setting);
            self.gradeList = res.data.gradeList;
            
            let grade_money = [];
            grade_money= setting.grade_money != '' ? JSON.parse(setting.grade_money) : [];

            self.gradeList.forEach(item=>{
              self.$set(item, 'grade_award', grade_money[item.grade_id]&&grade_money[item.grade_id].grade_award?grade_money[item.grade_id].grade_award:0);
              self.$set(item, 'same_award', grade_money[item.grade_id]&&grade_money[item.grade_id].same_award?grade_money[item.grade_id].same_award:0);
              self.$set(item, 'double_money', grade_money[item.grade_id]&&grade_money[item.grade_id].double_money?grade_money[item.grade_id].double_money:0);
             
            })
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

      },
      /*转JSON字符串*/
      convertJson(list,type){
        let obj={};

        list.forEach(item=>{
          if(type ==10){
            if(item.grade_id){
              obj[item.grade_id] = {'grade_award':item.grade_award ? item.grade_award: 0,'double_money':item.double_money ? item.double_money: 0,'same_award':item.same_award ? item.same_award: 0};
            }
          }
        });
        return JSON.stringify(obj);
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;

        params.grade_money = self.convertJson(self.gradeList,10);
        
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            Notetaking.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
                self.$router.push('/notetaking/setting/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/notetaking/setting/index.vue